module.exports = __webpack_public_path__ + "img/Greg.04759f5b.jpg";